export default __webpack_public_path__ + "static/media/create-project-modal-BG.d0bdd87a.png";